export var JoinByInviteStrings = {
    shared: {
        anotherAccountButton: function () { return 'Use another account'; },
    },
    chooseAccountView: {
        title: function (companyName) {
            return "Choose an account to join " + companyName + "'s meal benefits";
        },
        body: function () {
            return 'Your company is providing meal benefits. You can continue with the following account or use another one.';
        },
        currentAccountButton: function (email) { return "Use " + email; },
    },
    invalidInviteError: {
        title: function () { return 'Invalid invite link'; },
        body: function () {
            return 'We could not recognize your invite link. Please check your link and try again.';
        },
    },
    somethingWentWrongError: {
        title: function () { return 'Something went wrong'; },
        body: function () { return 'Please try again.'; },
        button: function () { return 'Try again'; },
    },
    useCompanyEmailError: {
        title: function () { return 'Please use your company email'; },
        body: function () {
            return 'We cannot find an invite for the logged in account. To join your company on DoorDash, please log in with your company email address.';
        },
        body2: function (consumerEmail) {
            return "You are currently logged in as " + consumerEmail + ".";
        },
        button: function () { return 'Log out to switch account'; },
    },
    tryADifferentAccountError: {
        title: function () { return 'Try a different account'; },
        body: function (companyName) {
            return "Your account is associated with " + companyName + ". To access your work benefits, log out and use another account.";
        },
    },
    existingMealBenefitsError: {
        title: function () { return 'Meal benefits already in your account'; },
        body: function (companyName) {
            return "You have already activated meal benefits from " + companyName + " using this account.";
        },
        body2: function (companyName2) {
            return "To activate this meal benefit from " + companyName2 + ", please log out and use another account.";
        },
        viewMyCurrentBenefitsButton: function () { return 'View my current meal benefits'; },
    },
};
